import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSignIn } from 'aws-amplify/auth';
import { Button, Container, Paper, Stack, Text } from '@mantine/core';
import PasswordRequirementInput from './common/PasswordRequirementInput';
import { isPasswordValid } from '../utils/passwordValidation';

function ChangeTemporaryPassword() {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError({}); // Clear any errors when user types
  };

  const validatePasswords = () => {
    if (!isPasswordValid(formData.newPassword)) {
      setError({newPassword: 'Password is missing required characters'});
      return false;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setError({confirmPassword: 'Passwords do not match'});
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePasswords()) return;

    setIsLoading(true);
    try {
      const signInResponse = await confirmSignIn({
        challengeResponse: formData.newPassword
      });

      if (signInResponse.isSignedIn) {
        navigate('/admin/calendar');
      } else {
        throw new Error('Failed to change password');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      setError(error.message || 'Failed to change password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Paper radius="md" p="xl" withBorder>
        <Text size="xl" fw={500} ta="center" mb="xl">
          Change Temporary Password
        </Text>

        <form onSubmit={handleSubmit}>
          <Stack gap="xl">
            {error.top && (
              <Text c="red" size="sm" ta="center">
                {error.top}
              </Text>
            )}

            <PasswordRequirementInput
              label="New Password"
              value={formData.newPassword}
              onChange={(e) => handleInputChange('newPassword', e.target.value)}
              placeholder="Enter new password"
              radius="md"
              required
              showRequirements={true}
              error={error.newPassword}
            />

            <PasswordRequirementInput
              label="Confirm Password"
              value={formData.confirmPassword}
              onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
              placeholder="Confirm new password"
              radius="md"
              required
              showRequirements={false}
              error={error.confirmPassword}
            />

            <Button 
              type="submit" 
              radius="xl"
              loading={isLoading}
              fullWidth
            >
              Change Password
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}

export default ChangeTemporaryPassword;